import OperationalReportQuickPage from './OperationalReportQuickPage';

export default OperationalReportQuickPage;
